export { default } from './CostsRangeTaskInputs';



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskSearchForm/CostsRangeTaskInputs/index.js